import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import CustomNavbar from "../components/Navbar";
import { useParams } from 'react-router-dom';
import Footer from "../components/Footer";
import TeamMembers from "../components/TeamMembers";
import { useLocation } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import BoardOfDirectors from '../components/BoardOfDirectors';
import axios from 'axios';
import Seo from '../components/Seo';
import { PAGE_SEO } from '../seo/pages';


const teamData = {
    "data": [
        {
            "id": 16,
            "documentId": "nlhxhym7dk6827q0j1vnjlmb",
            "Name": " Stan Bharti",
            "Position": "CHAIRMAN",
            "Description": "A professional mining engineer, consultant, international financier, seasoned entrepreneur and philanthropist, Stan has amassed over $3 billion in investment capital for resource companies and their shareholders. Thirty years of experience in finance, capital markets, and operations include various sectors; metals and mining, agriculture, energy, finance and technology. Having successfully acquired, financed, restructured and developed dozens of promising companies and bright startups globally. An expert in emerging markets, with a proven track record in leveraging existing teams, he uses his wealth of expertise and capital to build, incubate and sell global assets that generate high returns on investment for all stakeholders.\n\n",
            "order": 1,
            "createdAt": "2025-06-26T19:51:14.032Z",
            "updatedAt": "2025-06-26T19:51:14.032Z",
            "publishedAt": "2025-06-26T19:51:14.037Z",
            "image": {
                "id": 7,
                "documentId": "bnxrafr2cqx1w67ja6sks4d6",
                "name": "stan.png",
                "alternativeText": null,
                "caption": null,
                "width": 232,
                "height": 282,
                "formats": {
                    "thumbnail": {
                        "name": "thumbnail_stan.png",
                        "hash": "thumbnail_stan_c5195df167",
                        "ext": ".png",
                        "mime": "image/png",
                        "path": null,
                        "width": 128,
                        "height": 156,
                        "size": 51.22,
                        "sizeInBytes": 51217,
                        "url": "/uploads/thumbnail_stan_c5195df167.png"
                    }
                },
                "hash": "stan_c5195df167",
                "ext": ".png",
                "mime": "image/png",
                "size": 34.41,
                "url": "/uploads/stan_c5195df167.png",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "createdAt": "2025-06-26T19:51:11.879Z",
                "updatedAt": "2025-06-26T19:51:11.879Z",
                "publishedAt": "2025-06-26T19:51:11.879Z"
            }
        },
        {
            "id": 14,
            "documentId": "mcymd0cye6ur5m9p4i33altt",
            "Name": "Dr. Andreas Rompel",
            "Position": "CEO, DIRECTOR & VP EXPL.",
            "Description": "Dr. Rompel has over 30 years of exploration and mining experience in a wide range of roles. He has worked in a variety of commodities, including precious metals, base metals as well as coking coal and energy minerals. For more than a decade, Dr. Rompel evaluated capital projects within Anglo American and was on the board of Spectrem (an Anglo-American Company) as Technical Director. Previously, he worked in Peru where he was the Corporate Manager of Business Development for Hochschild Mining, responsible for the evaluation and acquisition of mining projects in North and South America.\n\n",
            "order": 2,
            "createdAt": "2025-06-26T19:50:33.912Z",
            "updatedAt": "2025-06-26T19:50:33.912Z",
            "publishedAt": "2025-06-26T19:50:33.917Z",
            "image": {
                "id": 6,
                "documentId": "vrgff4jexdilkudlcpj90ur3",
                "name": "andreas.png",
                "alternativeText": null,
                "caption": null,
                "width": 214,
                "height": 260,
                "formats": {
                    "thumbnail": {
                        "name": "thumbnail_andreas.png",
                        "hash": "thumbnail_andreas_553ecac088",
                        "ext": ".png",
                        "mime": "image/png",
                        "path": null,
                        "width": 128,
                        "height": 156,
                        "size": 37.2,
                        "sizeInBytes": 37197,
                        "url": "/uploads/thumbnail_andreas_553ecac088.png"
                    }
                },
                "hash": "andreas_553ecac088",
                "ext": ".png",
                "mime": "image/png",
                "size": 22.95,
                "url": "/uploads/andreas_553ecac088.png",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "createdAt": "2025-06-26T19:50:31.321Z",
                "updatedAt": "2025-06-26T19:50:31.321Z",
                "publishedAt": "2025-06-26T19:50:31.322Z"
            }
        },
        {
            "id": 12,
            "documentId": "xtn4nmxvyrwkgyidi2du19qh",
            "Name": "Peter Michel",
            "Position": "CHIEF FINANCIAL OFFICER",
            "Description": "Peter Michel is a CPA, CA and obtained a Bachelor of Accounting and Financial Management from the University of Waterloo. Mr. Michel formerly served in leadership roles in both public and private companies with most recent focus in healthcare. Additionally, he worked as a Senior Manager at BDO Canada LLP where he worked in its audit and assurance practice. He has expertise in strategic planning. financial reporting, budgeting, acquisitions, cash management and audit.\n\n",
            "order": 3,
            "createdAt": "2025-06-26T19:49:04.254Z",
            "updatedAt": "2025-06-26T19:49:30.413Z",
            "publishedAt": "2025-06-26T19:49:30.423Z",
            "image": {
                "id": 5,
                "documentId": "upvxo499sq6t3g8k07eb3jf7",
                "name": "peter.png",
                "alternativeText": null,
                "caption": null,
                "width": 226,
                "height": 274,
                "formats": {
                    "thumbnail": {
                        "name": "thumbnail_peter.png",
                        "hash": "thumbnail_peter_64153436ec",
                        "ext": ".png",
                        "mime": "image/png",
                        "path": null,
                        "width": 129,
                        "height": 156,
                        "size": 24.46,
                        "sizeInBytes": 24461,
                        "url": "/uploads/thumbnail_peter_64153436ec.png"
                    }
                },
                "hash": "peter_64153436ec",
                "ext": ".png",
                "mime": "image/png",
                "size": 13.42,
                "url": "/uploads/peter_64153436ec.png",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "createdAt": "2025-06-26T19:49:01.812Z",
                "updatedAt": "2025-06-26T19:49:01.812Z",
                "publishedAt": "2025-06-26T19:49:01.812Z"
            }
        },
        {
            "id": 9,
            "documentId": "n1hlx19m6esmracs1rtxhq9p",
            "Name": "Aaron Atin",
            "Position": "CORPORATE SECRETARY",
            "Description": "Mr. Atin is a corporate and securities lawyer who works as a legal consultant for various Toronto Stock Exchange and TSX Venture- Exchange listed companies in the mining industry. He was previously an associate at a large Toronto corporate law firm, where he worked on a variety of corporate, securities and commercial transactions. Mr. Atin studied at the University of Toronto, Faculty of Law, and University of Waterloo, where he obtained his Juris Doctor and Bachelor of Arts degree, respectively.\n\n",
            "order": 4,
            "createdAt": "2025-06-26T19:47:52.193Z",
            "updatedAt": "2025-06-26T19:47:52.193Z",
            "publishedAt": "2025-06-26T19:47:52.198Z",
            "image": {
                "id": 4,
                "documentId": "t3462bhlj1dpsfgtmy4drqdk",
                "name": "aaron.png",
                "alternativeText": null,
                "caption": null,
                "width": 234,
                "height": 258,
                "formats": {
                    "thumbnail": {
                        "name": "thumbnail_aaron.png",
                        "hash": "thumbnail_aaron_f21a7a2bb9",
                        "ext": ".png",
                        "mime": "image/png",
                        "path": null,
                        "width": 141,
                        "height": 156,
                        "size": 32.03,
                        "sizeInBytes": 32031,
                        "url": "/uploads/thumbnail_aaron_f21a7a2bb9.png"
                    }
                },
                "hash": "aaron_f21a7a2bb9",
                "ext": ".png",
                "mime": "image/png",
                "size": 21.89,
                "url": "/uploads/aaron_f21a7a2bb9.png",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "createdAt": "2025-06-26T19:47:48.783Z",
                "updatedAt": "2025-06-26T19:47:48.783Z",
                "publishedAt": "2025-06-26T19:47:48.784Z"
            }
        },
        {
            "id": 7,
            "documentId": "gce2ojnjziun4rmfdoatvn50",
            "Name": "Gregory Biniowski",
            "Position": "DIRECTOR",
            "Description": "Mr. Biniowsky is a Canadian trained and licensed lawyer who has been a director or officer to a number of international business ventures. He is a fluent Spanish speaker, with more than 30 years’ experience working in Latin America as a strategic advisor. He previously worked for the international law firms Gowling WLG and Heenan Blaikie, and also worked as an international development fund manager for the Canadian Department of Foreign Affairs and the United Nations Development Program. Mr. Biniowsky the Colombia, where Doctor from the University of British he obtained a Juris Faculty of Law, and previous to that, at Carleton University and York University, where he studied political science with a focus on Latin America.\n\n",
            "order": 5,
            "createdAt": "2025-06-26T19:46:32.172Z",
            "updatedAt": "2025-06-26T19:46:32.172Z",
            "publishedAt": "2025-06-26T19:46:32.176Z",
            "image": {
                "id": 3,
                "documentId": "ucture6mu6pwdmww60u0gya1",
                "name": "gregory.png",
                "alternativeText": null,
                "caption": null,
                "width": 234,
                "height": 268,
                "formats": {
                    "thumbnail": {
                        "name": "thumbnail_gregory.png",
                        "hash": "thumbnail_gregory_a2fab0c728",
                        "ext": ".png",
                        "mime": "image/png",
                        "path": null,
                        "width": 136,
                        "height": 156,
                        "size": 32.07,
                        "sizeInBytes": 32071,
                        "url": "/uploads/thumbnail_gregory_a2fab0c728.png"
                    }
                },
                "hash": "gregory_a2fab0c728",
                "ext": ".png",
                "mime": "image/png",
                "size": 20,
                "url": "/uploads/gregory_a2fab0c728.png",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "createdAt": "2025-06-26T19:46:30.022Z",
                "updatedAt": "2025-06-26T19:46:30.022Z",
                "publishedAt": "2025-06-26T19:46:30.022Z"
            }
        },
        {
            "id": 5,
            "documentId": "qorub7f94rfdrbszolip6qvw",
            "Name": "Robert Bryce",
            "Position": "DIRECTOR",
            "Description": "Mr. Bryce is a P.Eng., MBA graduate of the University of Toronto and of Western University with more than 50 years of practical and executive mining experience. From 1975- 1990, he led the Selbaie project from an advanced exploration project to a 7,500 tpd producing mine. The Selbaie mine was Quebec’s largest base metal producer for a quarter century. From\n\n",
            "order": 6,
            "createdAt": "2025-06-26T19:45:40.360Z",
            "updatedAt": "2025-06-26T19:45:40.360Z",
            "publishedAt": "2025-06-26T19:45:40.367Z",
            "image": {
                "id": 2,
                "documentId": "nx3vhsswwn6515g1ykgeibsw",
                "name": "ROBERT BRYCE .png",
                "alternativeText": null,
                "caption": null,
                "width": 220,
                "height": 260,
                "formats": {
                    "thumbnail": {
                        "name": "thumbnail_ROBERT BRYCE .png",
                        "hash": "thumbnail_ROBERT_BRYCE_927ff62b80",
                        "ext": ".png",
                        "mime": "image/png",
                        "path": null,
                        "width": 132,
                        "height": 156,
                        "size": 42.52,
                        "sizeInBytes": 42517,
                        "url": "/uploads/thumbnail_ROBERT_BRYCE_927ff62b80.png"
                    }
                },
                "hash": "ROBERT_BRYCE_927ff62b80",
                "ext": ".png",
                "mime": "image/png",
                "size": 21.6,
                "url": "/uploads/ROBERT_BRYCE_927ff62b80.png",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "createdAt": "2025-06-26T19:45:37.164Z",
                "updatedAt": "2025-06-26T19:45:37.164Z",
                "publishedAt": "2025-06-26T19:45:37.165Z"
            }
        },
        {
            "id": 3,
            "documentId": "are8puilvp82kcafh4x32z45",
            "Name": " Tito Ghandi",
            "Position": "DIRECTOR",
            "Description": "Mr. Gandhi has over 30 years of business experience in public and private markets buying, selling, and restructuring companies. He currently serves President and CEO of Genesis International Ltd., a company that builds and operates casinos in locations across the Caribbean, Asia and Russia. For 15 years, Mr. Gandhi served as President and CEO of Office Solutions, a leading supplier of Technology Solutions. The Office Solutions Group of Companies were acquired by Canon Japan. Mr. Ghandi has an HND in Business Studies from Hertfordshire University, UK.\n\n",
            "order": 7,
            "createdAt": "2025-06-26T19:27:14.472Z",
            "updatedAt": "2025-06-26T19:45:06.760Z",
            "publishedAt": "2025-06-26T19:45:06.769Z",
            "image": {
                "id": 1,
                "documentId": "sndt9tu7a4envkjmu3so6cmb",
                "name": " Tito Ghandi .png",
                "alternativeText": null,
                "caption": null,
                "width": 224,
                "height": 264,
                "formats": {
                    "thumbnail": {
                        "name": "thumbnail_ Tito Ghandi .png",
                        "hash": "thumbnail_Tito_Ghandi_8e88e68fca",
                        "ext": ".png",
                        "mime": "image/png",
                        "path": null,
                        "width": 132,
                        "height": 156,
                        "size": 33.24,
                        "sizeInBytes": 33241,
                        "url": "/uploads/thumbnail_Tito_Ghandi_8e88e68fca.png"
                    }
                },
                "hash": "Tito_Ghandi_8e88e68fca",
                "ext": ".png",
                "mime": "image/png",
                "size": 18.92,
                "url": "/uploads/Tito_Ghandi_8e88e68fca.png",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "createdAt": "2025-06-26T19:26:58.548Z",
                "updatedAt": "2025-06-26T19:26:58.548Z",
                "publishedAt": "2025-06-26T19:26:58.549Z"
            }
        }
    ],
    "meta": {
        "pagination": {
            "page": 1,
            "pageSize": 25,
            "pageCount": 1,
            "total": 7
        }
    }
}

const CompanyPage = () => {
    const { hash } = useLocation();
    const [teamMembers, setTeamMembers] = useState([]);
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.01,
    });

    const mapTeamMembers = (items = []) => {
        const baseURL = process.env.REACT_APP_BACKEND_API_URL || '';

        return items
            .map((item) => {
                const { Name, Position, Description, image, order } = item;

                const imageUrl = image?.url
                    ? `${baseURL}${image.url}`
                    : '/images/default.jpg';

                return {
                    id: item.id,
                    name: Name?.trim() || '',
                    position: Position || '',
                    description: Description || '',
                    imageUrl,
                    order: typeof order === 'number' ? order : 999,
                };
            })
            .filter(Boolean)
            .sort((a, b) => a.order - b.order);
    };

    const allMembers = mapTeamMembers(teamMembers);

    const boardMembers = allMembers.filter((m) => {
        const pos = m.position.toLowerCase();
        return pos.includes('chairman') || pos.includes('director') || pos.includes('ceo') || pos.includes('coo');
    });

    const managementMembers = allMembers.filter(
        (m) => !boardMembers.some((b) => b.id === m.id)
    );


    useEffect(() => {
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                const yOffset = -120;
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }
    }, [hash]);

    useEffect(() => {
        const fetchTeamMembers = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_API_URL}/api/team-members?populate=*&sort=order:asc`
                );
                setTeamMembers(res.data?.data || []);
            } catch (error) {
                console.error('Error fetching team members:', error);
            }
        };

        fetchTeamMembers();
    }, []);


    // useEffect(() => {
    //     const fetchTeamMembers = async () => {
    //         try {
    //             const res = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/team-members?populate=*&sort=order:asc`);

    //             const mappedMembers = res.data.data.map((item) => {
    //                 const { attributes, Name, Position, Description, image } = item;

    //                 const name = attributes ? attributes.Name : Name;
    //                 const position = attributes ? attributes.Position : Position;
    //                 const description = attributes ? attributes.Description : Description;
    //                 const order = attributes ? attributes.order : null;

    //                 const imageUrl = image?.url
    //                     ? `${process.env.REACT_APP_BACKEND_API_URL}${image.url}`
    //                     : '/images/default.jpg';

    //                 return {
    //                     id: item.id,
    //                     name,
    //                     position,
    //                     description,
    //                     imageUrl,
    //                     order
    //                 };
    //             }).filter(Boolean);

    //             setTeamMembers(mappedMembers);
    //         } catch (error) {
    //             console.error('Error fetching team members:', error);
    //         }
    //     };

    //     fetchTeamMembers();
    // }, []);


    return (
        <div>
            <Seo {...PAGE_SEO.company} />
            <CustomNavbar />
            <section className="company-page">
                <section className="company-page-banner text-center text-white"
                    style={{ backgroundImage: "url('/images/company-banner-new.png')" }}>
                    <h2>Company</h2>
                </section>
                <section ref={ref} className={` animate pt-5 ${inView ? 'slide-up' : ''}`}>
                    <Container>

                        <section id="about">
                            <h3 className="pt-2">About Us </h3>
                            <p><b>Q-Gold Resources Ltd.</b> is a North American gold exploration and development company advancing a dual-asset
                                platform in Tier-One jurisdictions. An advanced development asset in Oregon, USA and a large-scale exploration asset in Ontario, Canada. Q Gold is strategically positioned for near-term growth and long-term value creation.</p>
                            <p>In the United States, <b>Q-Gold has acquired a 100% interest in the Quartz Mountain Gold Project</b>, an advanced-stage asset with
                                over 100,000 meters of historical drilling and demonstrated heap leach potential.</p>
                            <div className="my-5">
                                <Row className="mb-4">
                                    <Col xs={12}>
                                        <h4 className="mb-3" style={{ color: '#0a2240', fontWeight: '700' }}>
                                            2026 Preliminary Economic Assessment (Updated: April 8 2026)
                                        </h4>
                                        <p>
                                            The PEA contemplates a conventional open-pit, heap-leach gold mine at the Quartz Mountain Gold Project in Lake County, Oregon, USA.
                                        </p>
                                        <img
                                            src="/images/2026-pea.webp"
                                            alt="2026 PEA"
                                            className="img-fluid rounded shadow-sm mt-3"
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} className="mb-4 mb-md-0">
                                        <div className="h-100">
                                            <table className="project-custom-table w-100 h-100" style={{ maxWidth: '100%' }}>
                                                <thead>
                                                    <tr className="first-head">
                                                        <th colSpan={2}>PEA Study Highlights (all values in US$)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="second-head">
                                                        <th colSpan={2}>LOM Production and Costs</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Mine Life</td>
                                                        <td className="bold">14 years</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Mine Throughput (Ore, Average)</td>
                                                        <td className="bold">7,300,000 Tonnes per year</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Metallurgical Recovery (Gold, Overall)</td>
                                                        <td className="bold">79.60%</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Average Annual Gold Production</td>
                                                        <td className="bold">135,400 oz / year (peak: 166,300 oz / year)</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Gold Produced (Life of Mine)</td>
                                                        <td className="bold">1,896,000 oz</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Cash Cost</td>
                                                        <td className="bold">$1,010/oz</td>
                                                    </tr>
                                                    <tr>
                                                        <td>All-In Sustaining Cost (AISC)</td>
                                                        <td className="bold">$1,216/oz</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Strip Ratio ( Waste : Ore )</td>
                                                        <td className="bold">0.65:1</td>
                                                    </tr>

                                                    <tr className="second-head">
                                                        <th colSpan={2}>Financial Analysis — Base Case ( 24-Month Trailing Average Gold Price US$3,265 )</th>
                                                    </tr>
                                                    <tr>
                                                        <td>After-Tax NPV (5%)</td>
                                                        <td className="bold">$1.707 Billion</td>
                                                    </tr>
                                                    <tr>
                                                        <td>After-Tax IRR</td>
                                                        <td className="bold">55.20%</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pre-Tax NPV (5%)</td>
                                                        <td className="bold">$2.214 Billion</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pre-Tax IRR</td>
                                                        <td className="bold">65.90%</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Average Annual Pre-Tax Cash Flow (LOM)</td>
                                                        <td className="bold">$171 Million</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Payback Period (After-Tax)</td>
                                                        <td className="bold">1.8 years</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="h-100">
                                            <table className="project-custom-table w-100 h-100" style={{ maxWidth: '100%' }}>
                                                <thead>
                                                    <tr className="first-head">
                                                        <th colSpan={2}>PEA Study Highlights (all values in US$)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="second-head">
                                                        <th colSpan={2}>Financial Analysis — Spot Gold Price (US$4,800 oz)(2)</th>
                                                    </tr>
                                                    <tr>
                                                        <td>After-Tax NPV (5%) at Spot</td>
                                                        <td className="bold">$3.20 Billion</td>
                                                    </tr>
                                                    <tr>
                                                        <td>After-Tax IRR at Spot</td>
                                                        <td className="bold">92 %</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Payback Period at Spot</td>
                                                        <td className="bold">1.2 years</td>
                                                    </tr>

                                                    <tr className="second-head">
                                                        <th colSpan={2}>Capital Costs (Sales Tax Included)</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Initial Capital</td>
                                                        <td className="bold">US$290 Million</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Working Capital & Initial Fills</td>
                                                        <td className="bold">US$9 Million</td>
                                                    </tr>
                                                    <tr>
                                                        <td>LOM Sustaining Capital</td>
                                                        <td className="bold">US$360 Million</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Reclamation & Closure</td>
                                                        <td className="bold">US$56 Million</td>
                                                    </tr>

                                                    <tr className="second-head">
                                                        <th colSpan={2}>Operating Costs (Average LOM)</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Mining</td>
                                                        <td className="bold">US$4.09 / Tonne Mined</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Processing & Support</td>
                                                        <td className="bold">US$9.24 / Tonne Processed</td>
                                                    </tr>
                                                    <tr>
                                                        <td>G&A</td>
                                                        <td className="bold">US$0.66 / Tonne Processed</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <p>In Canada, Q-Gold holds a significant land position at <b>Mine Centre, Ontario,</b> anchored by the historically
                                productive Foley Mine. The project features high-grade gold intercepts, mapped quartz vein systems, and a fully
                                permitted drill program targeting near-surface resource expansion.</p>
                            <p>Led by a proven management team and advancing projects in two of the world's most mining-friendly jurisdictions, <b>Q Gold is on track to become America's Next Tier-One Gold Developer.</b></p>
                        </section>

                        <section id="esg">
                            <h3 className="mt-3">ESG</h3>
                            <p><b> QGold ESG Commitment Statement</b><br /> At QGold, we recognize that responsible mineral development is essential to building a sustainable future. As a company with active exploration and development projects in Oregon and Northern Ontario, we are committed to upholding the highest standards of Environmental, Social, and Governance (ESG) performance across all aspects of our operations. </p>

                            <p>
                                <b> Environmental Stewardship</b><br /> We prioritize environmental protection through proactive planning, regulatory compliance, and continuous improvement. Our exploration and development activities are designed to minimize ecological impact, safeguard water and air quality, and promote responsible land use. We are committed to integrating innovative technologies and best practices to reduce our carbon footprint and support biodiversity in the regions where we operate.</p>

                            <p>
                                <b> Social Responsibility</b><br /> QGold values meaningful engagement with local communities, Indigenous partners, and stakeholders. We strive to foster transparent communication, respect cultural heritage, and contribute positively to regional development. Our operations aim to create local employment opportunities, support community initiatives, and uphold human rights and workplace safety.</p>

                            <p>
                                <b> Governance and Ethics</b><br /> Integrity, accountability, and transparency are the cornerstones of our governance framework. QGold adheres to ethical business practices, rigorous internal controls, and regulatory compliance across jurisdictions. Our leadership is committed to continuous oversight and risk management to ensure responsible decision-making and long-term value creation.<br /><br />
                                QGold is dedicated to evolving our ESG strategy as our projects advance, ensuring that sustainability remains central to our growth and operational excellence.
                            </p>
                        </section>

                    </Container>
                    <BoardOfDirectors boardofDirectors={boardMembers} />
                    <TeamMembers teamMembers={managementMembers} />

                </section>

            </section >
            <Footer />
        </div >
    );
};

export default CompanyPage;
